<style lang="less" scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.verAddCon{
    position: relative;
    .title{
        font-size: 20px;
        padding: 4px 0 20px;
    }
    .colseButton{
        position: absolute;
        right: -18px;
        top:-18px
    }
    /deep/ .ivu-form .ivu-form-item-label {
        width: 160px !important;
        text-align: left !important;
        text-indent: 1px;
    }
    /deep/ .ivu-form-item-content{
       margin-left: 160px !important;
    }
}
</style>

<template>
<div class="verAddCon"  v-if='showModel'>
        <div class="title">{{$t('firmwareVersion.addButton')}}</div>
        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />

         

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">

            <Tabs type="card">
                 <TabPane :label="$t('firmwareVersion.addBox.title1')">
                    <FormItem :label="$t('editMesageModule.lang_zh')" prop="zh" style="width: 500px">
                        <Input type="text" v-model.trim="formData.zh" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_zh_ft')" prop="zh_ft" style="width: 500px">
                        <Input type="text" v-model.trim="formData.zh_ft" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_en')" prop="en" style="width: 500px">
                        <Input type="text" v-model.trim="formData.en" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_fr')" prop="fr" style="width: 500px">
                        <Input type="text" v-model.trim="formData.fr" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_de')" prop="de" style="width: 500px">
                        <Input type="text" v-model.trim="formData.de" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_es')" prop="es" style="width: 500px">
                        <Input type="text" v-model.trim="formData.es" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_ja')" prop="ja" style="width: 500px">
                        <Input type="text" v-model.trim="formData.ja" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                 </TabPane>
                 <TabPane :label="$t('firmwareVersion.addBox.title2')">
                    <FormItem :label="$t('firmwareVersion.addBox.fileName')" prop="fileName" class="ivu-form-item-required" style="width: 500px">
                        <upload-file ref='upFile' :num='1' :action='upFileUrl' :types='["bin","zip"]' :formatError="$t('firmwareVersion.require.formatError')"  @setThumbUrl='setThumbUrl'></upload-file>
                    </FormItem>
                    <FormItem  :label="$t('firmwareVersion.titleName.hardwareVersion')"  class="ivu-form-item-required" prop="hardware" style="width: 500px">
                        <!-- <div >{{formData.hardware}}</div> -->
                        <Input type="text" :placeholder="$t('inputPlaceholder')" disabled :value="formData.hardware"></Input>
                    </FormItem>

                    <FormItem :label="$t('firmwareVersion.titleName.fwareVersion')" class="ivu-form-item-required" prop="fwareVersion" style="width: 500px">
                        <!-- <div >{{formData.fwareVersion}}</div> -->
                        <Input type="text" :placeholder="$t('inputPlaceholder')" disabled :value="formData.fwareVersion"></Input>
                    </FormItem>

                    <!-- <FormItem v-else :label="$t('firmwareVersion.titleName.fwareVersion')" prop="fwareVersion" style="width: 500px">
                        <Input type="text" v-model.trim="formData.fwareVersion" :placeholder="$t('inputPlaceholder')+'eg: WV100LR-V000R005C01B001'" ></Input>
                    </FormItem> -->
                    <FormItem :label="$t('firmwareVersion.titleName.suitDeviceType')" prop="suitDeviceType" style="width: 500px">
                        <Input type="text" v-model.trim="formData.suitDeviceType" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
        
                    <FormItem :label="$t('firmwareVersion.titleName.releaseTime')" prop="releaseTime" style="width: 500px">
                        <DatePicker type="date" :value="formData.releaseTime1" :placeholder="$t('selectPlaceholder')" @on-change='selectT' transfer  format="yyyy-MM-dd" style="width: 340px"></DatePicker>
                    </FormItem>
        
                    <FormItem>
                        <Button :loading="disabled"  type="primary" @click="subData('formData')" style="marginRight:20px">{{$t('save')}}</Button>
                        <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
                    </FormItem>
                 </TabPane>
             </Tabs>
    
            


          
        </Form>

    <!-- </Modal> -->
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import uploadFile from '../../common/uploadFiles.vue'
import { mapState } from 'vuex'
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            offModel: Boolean
        },
        name: "Model3",
        components: {
            uploadFile
        },
        data() {
            return {   
                upFileUrl:this.config.urlArray.uploadFware,
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    updateInformation:'',
                    fwareVersion: '',
                    releaseTime:'',
                    releaseTime1:'',
                    suitDeviceType:'',
                    fileId:'',//278852ee306a4fdc93f8650cbb8abd0a
                    fileName:'',//nvdata.bin
                    hardware:'',
                    zh:'',
                    zh_ft:'',
                    en:'',
                    fr:'',
                    de:'',
                    es:'',
                    ja:'',
                }, 
               
            }
        },
        watch:{
            showModel(val){
                if(val === true) {   

                  
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                    this.$refs.upFile.clearImg()
                }
            },
        },
        computed:{
             ...mapState(['local','selectId']),
             ruleCustom(){
                 return {//验证
                    // fwareVersion: [
                    //     {required: true, message: this.$t('required'),trigger: 'blur' },
                    // ],
                    releaseTime: [
                        {required: true, message: this.$t('required'),trigger: 'change',pattern: /.+/  },
                    ],
                    suitDeviceType: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    zh: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    zh_ft: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    en: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    fr: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    de: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    es: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    ja: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    
                }
             } 

        },
        created(){
           
        },
        methods: {
            setThumbUrl(obj){
                // console.log(obj)
               if(!obj.data){
                    common.msg('error',obj.file.response)
                    return
               }
               this.formData.fileId = obj.data.fId
               this.formData.fileName = obj.file.name
               this.formData.hardware = obj.data.hardware
               this.formData.fwareVersion = obj.data.fwareVersion
            },
            selectT(val){
               this.formData['releaseTime1'] = val
               this.formData['releaseTime'] = new Date(val).getTime()    
            },
            setSelectVal(e,key){
                 this.formData[key] = e.nameVal+''
            },
            subData(name) {//提交表单
                

                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if(!this.formData.hardware || !this.formData.fwareVersion){
                            common.msg('error',this.$t('firmwareVersion.require.hardwareVersion'))
                            return
                        }

                    

                        this.disabled = true;
                        this.formData.updateInformation = '#'+'&zh&'+this.formData.zh+'&zh&'
                                                             +'&zh_TW&'+this.formData.zh_ft+'&zh_TW&'
                                                             +'&zh_HK&'+this.formData.zh_ft+'&zh_HK&'
                                                             +'&en&'+this.formData.en+'&en&'
                                                             +'&fr&'+this.formData.fr+'&fr&'
                                                             +'&de&'+this.formData.de+'&de&'
                                                             +'&es&'+this.formData.es+'&es&'
                                                             +'&ja&'+this.formData.ja+'&ja&'
                                                             +'#'
                        // console.log({...this.formData,dealerId:this.selectId})
                        this.axios.post(this.config.urlArray.fwaresAdd, {...this.formData,dealerId:this.selectId}).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false})
                        
                        }).catch((err) => {
                            console.log(err)
                            // common.msg('error','提交失败',()=>{this.disabled = false;})
                            this.disabled = false
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.$emit('update:showModel',false);
                this.$emit('update:offModel',true);
                this.formData.releaseTime1 = ''
                this.formData.updateInformation = ''
                this.formData.hardware = ''
                
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>